import { navigateTo } from "gatsby-link/index";
import React from 'react'
import Link from 'gatsby-link'

import logoBlack from '../images/logo-black.svg'
const goToImdf = () => {
    if(typeof window === 'undefined') {
        setTimeout(goToImdf, 100);
        console.log('no window')
        return
    }
    if(window.location.hash !== '#imdf') {
        return
    }
    var element = document.getElementById("imdf");
    if(element) {
        element.scrollIntoView();
    } else {
        setTimeout(goToImdf, 100);
    }
}
setTimeout(goToImdf, 100);

const Footer = () => (
  <footer id="footer">
    <div className="container">
      <div className="logo-col">
          <div className="logo">
              <Link to="/">
                <img
                    className="default-logo"
                    src={logoBlack}
                    width="150"
                    height="24"
                    alt="LocusLabs"
                />
              </Link>
          </div>
        <span className="copy-right">
          Copyright &copy;
          <div className="year">{new Date().getYear() + 1900}</div>
          All Rights Reserved
        </span>
      </div>
      <div className="footer-box">
        <nav className="nav-col">
          <h4>Products</h4>
          <ul>
            <li>
              <Link to="/LocusMaps/">LocusMaps</Link>
            </li>
            <li>
              <Link to="/LocusVMS/">LocusVMS</Link>
            </li>
            <li>
              <Link to="/LocusEnterprise/">LocusEnterprise</Link>
            </li>
          </ul>
        </nav>
        <nav className="nav-col">
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/about/">About Us</Link>
            </li>
          </ul>
        </nav>
        { /* <nav className="nav-col">
          <h4>Support</h4>
          <ul>
            <li>
              <Link to="/support/">Support</Link>
            </li>
          </ul>
        </nav> */ }
        <div className="social-col">
          <h4>TWITTER</h4>
          <ul>
            <a href="https://www.twitter.com/locuslabs">@LocusLabs</a>
          </ul>
        </div>
        <div className="contact-col">
          <h4>Contact US</h4>
          <ul>
            <li>
              <Link to="/contact/">Send Message</Link>
            </li>
            <li>
              <a onClick={() => navigateTo('/contact/')}>Request A Demo</a>
            </li>
          </ul>
          <address className="address">
            331 Jefferson Street <br />Oakland, CA 94607 <br />USA
          </address>
        </div>
        <nav className="nav-col">
          <h4>LOGIN</h4>
          <ul>
            <li>
              <a href="https://vms.locuslabs.com">LocusVMS Login</a>
            </li>
            { <li>
              <Link to="/support/">Support</Link>
            </li> }
          </ul>
        </nav>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js